import { render, staticRenderFns } from "./HistoryFormList.vue?vue&type=template&id=ab52ae16&"
import script from "./HistoryFormList.vue?vue&type=script&lang=js&"
export * from "./HistoryFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports